import { selectObject } from "../../containers/UnityLabeler/unity_api";
export var addInference = function addInference(payload) {
  return {
    type: 'ADD_INFERENCE',
    payload: payload
  };
};
export var displayInferences = function displayInferences() {
  return {
    type: 'DISPLAY_INFERENCES'
  };
};
export var calculateScore = function calculateScore() {
  return {
    type: 'CALC_SCORE'
  };
};
export var selectInference = function selectInference(inference) {
  selectObject(inference);
  return {
    type: 'SELECT_INFERENCE',
    inference: inference
  };
};